import { UseMutationOptions } from "@tanstack/react-query";
import { API_ACCEPT_DISCLAIMER_MUTATION } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";

export interface IAcceptDisclaimerResponse {
    newUrl: string;
}

export interface IAcceptDisclaimerRequest {
    country: string;
    url: string;
    storeCookie?: boolean;
}

interface IError {
    [fieldName: string]: string;
}

export const useAcceptDisclaimerMutation = (options: UseMutationOptions<IAcceptDisclaimerResponse, IError, IAcceptDisclaimerRequest>) => {
    const { mutate } = useMutation<IAcceptDisclaimerResponse, IError, IAcceptDisclaimerRequest>(API_ACCEPT_DISCLAIMER_MUTATION, options);
    return mutate;
};
